import getGeocodeData from './geocodeio-service';
import getCivicData from './google-civic-service';

export default function getRepresentatives(endUserLocation, address, search) {
    if (address != null) {
        return getGeocodeData(null, null, address).then(data =>
            getCivicData(data, search)
        );
    }
    return (
        getGeocodeData(endUserLocation.latitude, endUserLocation.longitude, null)
            // .then(() => getGeocodeData('37.757078', ' -122.423827'))
            // .then(() => getGeocodeData('38.95261', ' -77.017898')) // no senators are loaded
            .then(data => getCivicData(data, search))
            .then(data => {
                return new Promise(resolve => {
                    if (data.photoUrl == null) return resolve(data);

                    const imagePreload = new Image();
                    imagePreload.src = data.photoUrl;
                    imagePreload.onload = () => resolve(data);
                });
            })
    );
}
